// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2fZOY","subheader":"ReorderModal_subheader__1Ey1B","listWrap":"ReorderModal_listWrap__turQK"};